import CoordinateConversion from "@arcgis/core/widgets/CoordinateConversion";
export function CoordinateConversionImp(widgetSettings) {
    let ccWidget = new CoordinateConversion({
        view: widgetSettings.view
    });
    // Adds widget in the bottom left corner of the view
    widgetSettings.view.ui.add(ccWidget, widgetSettings.widgetPosition);
}
